import React, {Component} from 'react';
import {withParams} from "../../App";
import PageComponent from "../pageComponent/pageComponent";
import Prism from 'prismjs';
import $ from "jquery";
import {toast} from "react-toastify";

class MachineLearningPage extends Component {


    slugs = [
        {
            slug: 'what-is-machine-learning',
            source: '/ml/what-is-machine-learning.html',
            title: 'What is Machine Learning',
            tags: ['Supervised', 'UnSupervised'], sourceLinks: [], languages: [], algos: [], attributed: []
        },
        {
            slug: 'brief-history-of-machine-learning',
            source: '/ml/brief-history-of-machine-learning.html',
            title: 'Brief History of Machine Learning',
            tags: [], sourceLinks: [], languages: [], algos: [], attributed: []
        },
        {
            slug: 'how-do-machines-learn',
            source: '/ml/how-do-machines-learn.html',
            title: 'How do Machines Learn',
            tags: [], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'machine-learning-frameworks',
            source: '/ml/machine-learning-frameworks.html',
            title: 'Common Machine Learning Frameworks',
            tags: [], sourceLinks: [], languages: ['Python', 'C#', 'Java'], algos: [], attributed: []
        },
        {
            slug: 'machine-learning-classification',
            source: '/ml/classification.html',
            title: 'Classification',
            tags: ['Binary Classification', 'Clustering'],
            sourceLinks: [],
            languages: ['C#'],
            algos: ['K-Means'],
            attributed: []
        },
        {
            slug: 'data-bias-in-machine-learning',
            source: '/ml/data-bias-in-machine-learning.html',
            title: 'Data Bias',
            tags: ['Data'], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'types-of-neural-networks',
            source: '/ml/types-of-neural-networks.html',
            title: 'Types of Neural Networks',
            tags: ['MLP', 'FeedForward'], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'common-machine-learning-algorithms',
            source: '/ml/common-machine-learning-algorithms.html',
            title: 'Common Machine Learning Algorithms',
            tags: [], sourceLinks: [], languages: ['C#'], algos: ['K-Means'], attributed: []
        },
        {
            slug: 'when-to-not-use-machine-learning',
            source: '/ml/when-to-not-use-machine-learning.html',
            title: 'When to not use Machine Learning',
            tags: [], sourceLinks: [], languages: [], algos: [], attributed: []
        },
        {
            slug: 'binary-classification',
            source: '/ml/classification.html',
            title: 'Classification',
            tags: ['Binary Classification'], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'basic-classification-problem',
            source: '/ml/basic-classification-problem.html',
            title: 'Basic Classification Problem',
            tags: [], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'basic-regression',
            source: '/ml/basic-regression.html',
            title: 'Regression',
            tags: [], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'basic-regression-problem',
            source: '/ml/basic-regression-problem.html',
            title: 'Basic Regression Problem',
            tags: [], sourceLinks: [], languages: ['C#'], algos: [], attributed: []
        },
        {
            slug: 'data-and-feature-engineering',
            source: '/ml/data-and-feature-engineering.html',
            title: 'Data and Feature Engineering',
            tags: ['Data', 'Normalization', 'Features'],
            sourceLinks: [],
            languages: ['Python', 'C#'],
            algos: [],
            attributed: []
        },
        {
            slug: 'large-data-sets',
            source: '/ml/large-data-sets.html',
            title: 'Dealing with Large Datasets',
            tags: ['Data'], sourceLinks: [], languages: ['Python', 'C#'], algos: [], attributed: []
        },
        {
            slug: 'transformers',
            source: '/ml/transformers.html',
            title: 'Transformers',
            tags: ['Models', 'RNNs', 'LSTM'],
            sourceLinks: [],
            languages: ['Python', 'C#'],
            algos: [],
            attributed: ['https://arxiv.org/pdf/1706.03762.pdf']
        },
        //================================== Tutorials ========================================
        {
            slug: 'mlnet-getting-started-cli',
            source: '/tutorials/mlnet/mlnet-getting-started-cli.html',
            title: 'Getting started with the Command Line',
            tags: [],
            sourceLinks: [],
            languages: ['C#'],
            algos: [],
            attributed: []
        },
        {
            slug: 'mlnet-getting-started-ide',
            source: '/tutorials/mlnet/mlnet-getting-started-ide.html',
            title: 'Getting started in an IDE',
            tags: [],
            sourceLinks: [],
            languages: ['C#'],
            algos: [],
            attributed: []
        },
        {
            slug: 'mlnet-classification-tutorial',
            source: '/tutorials/mlnet/mlnet-classification-tutorial.html',
            title: 'Classification Tutorial',
            tags: [],
            sourceLinks: [],
            languages: ['C#'],
            algos: [],
            attributed: []
        },
        {
            slug: 'mlnet-binary-image-classification',
            source: '/tutorials/mlnet/mlnet-binary-image-classification.html',
            title: 'MLNET Image Classification Tutorial',
            tags: [],
            sourceLinks: [],
            languages: ['C#'],
            algos: [],
            attributed: []
        },
        {
            slug: 'mlnet-basic-regression-tutorial',
            source: '/tutorials/mlnet/mlnet-basic-regression-tutorial.html',
            title: 'Regression',
            tags: [],
            sourceLinks: [],
            languages: ['C#'],
            algos: [],
            attributed: []
        },
        {
            slug: 'mlnet-time-series-tutorial',
            source: '/tutorials/mlnet/mlnet-time-series.html',
            title: 'Basic Time Series Analysis',
            tags: [],
            sourceLinks: [],
            languages: ['C#'],
            algos: [],
            attributed: []
        }
        //================================== Examples ========================================
    ];


    nextPage = [
        {
            key: 'what-is-machine-learning',
            slug: 'how-do-machines-learn',
            title: 'How do machines learn',
            path: '/machine-learning/basics/'
        },
        {
            key: 'brief-history-of-machine-learning',
            slug: 'how-do-machines-learn',
            title: 'How do machines learn',
            path: '/machine-learning/basics/'
        },
        {
            key: 'how-do-machines-learn',
            slug: 'machine-learning-frameworks',
            title: 'Common ML frameworks',
            path: '/machine-learning/basics/'
        },
        {
            key: 'machine-learning-frameworks',
            slug: '',
            title: 'Machine Learning',
            path: '/machine-learning/'
        },
        {
            key: 'machine-learning-classification',
            slug: '/ml/classification.html',
            title: 'Basics of Classification',
            path: '/machine-learning/'
        },
        {
            key: 'data-bias-in-machine-learning',
            slug: 'data-and-feature-engineering',
            title: 'Data and Feature Engineering',
            path: '/machine-learning/basics/'
        },

        {
            key: 'data-and-feature-engineering',
            slug: '',
            title: 'Machine Learning',
            path: '/machine-learning/'
        },
        {
            key: 'mlnet-getting-started-cli',
            slug: 'mlnet-getting-started-ide',
            path: '/tutorials/'
        }
    ]


    relatedPages = [
        {
            id: 1,
            key: 'what-is-machine-learning',
            title: 'Brief history of Machine Learning',
            slug: "brief-history-of-machine-learning",
            link: '/machine-learning/basics/'
        },
        {
            id: 2,
            key: 'what-is-machine-learning',
            title: 'Common Machine Learning Frameworks',
            slug: "machine-learning-frameworks",
            link: '/machine-learning/basics/'
        },
        {
            id: 3,
            key: 'what-is-machine-learning',
            title: 'How do machines learn?',
            slug: "how-do-machines-learn",
            link: '/machine-learning/basics/'
        },

        {
            id: 4,
            key: 'mlnet-getting-started-cli',
            title: 'Getting started with ML.NET in the IDE',
            slug: "mlnet-getting-started-ide",
            link: '/tutorials/'
        },

        {
            id: 5,
            key: 'brief-history-of-machine-learning',
            title: 'How do machines learn?',
            slug: "how-do-machines-learn",
            link: '/machine-learning/basics/'
        },
        {
            id: 6,
            key: 'brief-history-of-machine-learning',
            title: 'Common Machine Learning Frameworks',
            slug: "machine-learning-frameworks",
            link: '/machine-learning/basics/'
        },

        {
            id: 7,
            key: 'how-do-machines-learn',
            title: 'Brief history of Machine Learning',
            slug: "brief-history-of-machine-learning",
            link: '/machine-learning/basics/'
        },
        {
            id: 8,
            key: 'how-do-machines-learn',
            title: 'Common Machine Learning Frameworks',
            slug: "machine-learning-frameworks",
            link: '/machine-learning/basics/'
        }, {
            id: 9,
            key: 'transformers',
            title: 'Google Paper',
            slug: "transformers",
            link: 'https://arxiv.org/pdf/1706.03762.pdf'
        },

    ]

    suggestedCourses = [
        /*  { id: 1, key: 'what-is-machine-learning', title:'Brief history of Machine Learning', slug:"brief-history-of-machine-learning", link: '/machine-learning/basics/' },
          { id: 2, key: 'what-is-machine-learning', title:'Common Machine Learning Frameworks', slug:"machine-learning-frameworks", link: '/machine-learning/basics/' },
          { id: 3, key: 'what-is-machine-learning', title:'How do machines learn?', slug:"how-do-machines-learn", link: '/machine-learning/basics/' },

          { id: 4, key: 'mlnet-getting-started-cli', title:'Getting started with ML.NET in the IDE', slug:"mlnet-getting-started-ide", link: '/tutorials/' },

          { id: 5, key: 'brief-history-of-machine-learning', title:'How do machines learn?', slug:"how-do-machines-learn", link: '/machine-learning/basics/' },
          { id: 6, key: 'brief-history-of-machine-learning', title:'Common Machine Learning Frameworks', slug:"machine-learning-frameworks", link: '/machine-learning/basics/' },

          { id: 7, key: 'how-do-machines-learn', title:'Brief history of Machine Learning', slug:"brief-history-of-machine-learning", link: '/machine-learning/basics/'  },
          { id: 8, key: 'how-do-machines-learn', title:'Common Machine Learning Frameworks', slug:"machine-learning-frameworks", link: '/machine-learning/basics/' },*/

    ]

    render() {

        const slug = this.props?.params?.slug || window.location.pathname.split('/').filter(Boolean).slice(-1)[0] || '';
        const path = this.slugs.filter(path => path.slug === slug);
        const current = path[0] || {
            title: 'Machine Learning',
            tags: [],
            sourceLinks: [],
            languages: [],
            algos: [],
            attributed: [],
            source: '',
            dataFile: '',
            download: ''
        };

        if (path.length === 0) {
            console.error('MachineLearningPage Failed to located HTML path for slug : ' + slug);
        }

        const next = this.nextPage.filter(item => item.key === slug)[0];
        const related = this.relatedPages.filter(item => item.key === slug);
        const suggested = this.suggestedCourses.filter(item => item.key === slug);

        const state = {
            nextContent: next !== undefined ? next : {
                key: '',
                slug: '',
                title: 'Machine Learning',
                path: '/machine-learning/'
            },
            relatedContent: related,
            title: current.title,
            tags: current.tags,
            sourceLinks: current.sourceLinks,
            languages: current.languages,
            algos: current.algos !== undefined ? current.algos : [],
            suggestedCourses: suggested,
            attributed: current.attributed,
            source: current.source,
            html: '',
            dataFile: current.dataFile,
            download: current.download,
            type: "Article"
        };

        return (
            <PageComponent props={state} page="ML Page"/>
        );
    }

    attachCopyTagHandlers() {

        console.log("Checking for Tags and copy buttons");

        const copy = $('button.listing-action');
        const tags = $('span.js-tag-group-entry');

        console.log('Tags :' + tags.length + '  ' + tags[0].innerHTML);
        console.log("Copy :" + copy.length);

        copy.on('click', function () {
            const data = $(this).parent().siblings().first().children().first().text();
            const message = ({closeToast}) => (
                <div className="toasty-preview">
                    <p><strong>{data}</strong></p>
                    <p>Has been added to the clipboard</p>
                    <button onClick={closeToast}>Dismiss</button>
                </div>
            )
            toast(message, {
                toastId: '007',
                autoClose: 2500
            });
        });

        // With the current setup the handler can be added multiple times
        tags.off('click').on('click', function () {
            const data = $(this).text();

            console.log('Tag clicked with tag: ' + data);

            const message = ({closeToast}) => (
                <div>
                    <p><strong>{data}</strong></p>
                    <p>Tag search is currently disabled</p>
                    <button onClick={closeToast}>Dismiss</button>
                </div>
            )
            toast(message, {
                toastId: '007',
                autoClose: 2500
            });
        });

    }
}



export default withParams(MachineLearningPage);
